import { render } from "./ArgonPagination.vue?vue&type=template&id=1a5f5b04&scoped=true"
import script from "./ArgonPagination.vue?vue&type=script&lang=js"
export * from "./ArgonPagination.vue?vue&type=script&lang=js"

import "./ArgonPagination.vue?vue&type=style&index=0&id=1a5f5b04&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5f5b04"]])

export default __exports__